module.exports = __webpack_public_path__ + "img/api_06.1867a721.png";